import { cn } from "@/shared/lib/cn";

/** A pulsing dot: something is being timed right now. Still for people who prefer less motion. */
export function LiveDot({ className }: { className?: string }) {
  return (
    <span aria-hidden="true" className={cn("relative flex size-2 shrink-0", className)}>
      <span className="absolute inline-flex size-full animate-ping rounded-full bg-brand opacity-50 motion-reduce:hidden" />
      <span className="relative inline-flex size-2 rounded-full bg-brand" />
    </span>
  );
}
